import { Entity, PartPair, ReplaceAssemblyPartUtils } from '@inter-ikea-core/core';
import { CustomizedSlidingDoorComponent } from '@inter-ikea-storageone/range-pax';
import { CoreApi } from '@inter-ikea-storageone/range';
import { panelParts } from '../panelLayoutConfig';
import PanelLayout from '../types/PanelLayout';
import PanelSelection from '../types/PanelSelection';

const applyPanelLayout: (
  doorEntity: Entity,
  panelLayout: PanelLayout,
  panelProductPrimary: string,
  panelProductSecondary: string,
  coreApi: CoreApi
) => void = (doorEntity, panelLayout, panelProductPrimary, panelProductSecondary, coreApi) => {
  const parts = panelParts.map(
    (partKey, index) =>
      new PartPair(
        partKey,
        panelLayout.layout[index] === PanelSelection.Primary
          ? panelProductPrimary
          : panelProductSecondary
      )
  );

  doorEntity.addComponent(new CustomizedSlidingDoorComponent(panelLayout.arrangement));
  ReplaceAssemblyPartUtils.replaceProductParts(doorEntity, parts, coreApi.getServices());
};

export default applyPanelLayout;
